import React from 'react';
import { Flex, Input, Form, message, Divider, Button, Upload, Space, Modal, Checkbox } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { getCurrentShopId } from '../shop/get-current-shop';
import PageEditor from './page-editer/editor';
import SwitchShop from '../shop/switch-shop';
import './page-editer/dialog/dialog.css';

export default (props) => {
    console.log('=======globale, props', props)
    const [shopId, setShopId] = React.useState(null);
    const imageUrlPrefix = '//img.yxdj.tech/';
    const params = new URLSearchParams(window.location.search);
    const [form] = Form.useForm();
    const pageCode = Form.useWatch('code', form);
    // 系统页面（index/goodsList/goodsDetail 等 code 非 custom）名称由系统固定，不允许修改
    const isSystemPage = !!pageCode && pageCode !== 'custom';
    const [loading, setLoading] = React.useState(false);
    const [imageUrl, setImageUrl] = React.useState();
    const [shareSmallImg, setShareSmallImg] = React.useState([]);
    const [shareLargeImg, setShareLargeImg] = React.useState([]);
    const [sharePosterImg, setSharePosterImg] = React.useState([]);
    const [pageCtn, setPageCtn] = React.useState({
        load: false,
        content: null
    });
    const [syncModalVisible, setSyncModalVisible] = React.useState(false);
    const [availableShops, setAvailableShops] = React.useState([]);
    const [selectedShopIds, setSelectedShopIds] = React.useState([]);
    const [syncLoading, setSyncLoading] = React.useState(false);
    const pageContentRef = React.useRef(null);
    const handleChange = (fieldName, {file, fileList}) => {
        // console.log(file.status, fieldName, file, fileList);

        if(file.status === undefined) return false;

        if(file.status === 'done') {
            let thumbUrl = file.response.data.url.replace('http://weijia-hz-pub.oss-cn-hangzhou.aliyuncs.com', 'https://img.yxdj.tech');
            let imgUrl = file.response.data.url.replace('http://weijia-hz-pub.oss-cn-hangzhou.aliyuncs.com/', '');

            fileList = fileList.map((item) => {

                if(file.uid === item.uid) {
                    return { uid: item.uid, type: item.type, thumbUrl: thumbUrl + '?x-oss-process=image/resize,w_200', url: imgUrl }
                } else {
                    return item
                }
            });
        }

        if(file.status === 'done') console.log('done', fileList);

        if(fieldName === 'shareSmallImg') {
            setShareSmallImg([
                ...fileList,
            ]);
        }else if(fieldName === 'shareLargeImg') {
            setShareLargeImg([
                ...fileList,
            ]);
        }else if(fieldName === 'sharePosterImg') {
            setSharePosterImg([
                ...fileList,
            ]);
        }

        if (file.status === 'done') {
            setLoading(false);
        }else{
            if(loading === false) setLoading(true);
        }
    };

    const uploadButton = (
        <button style={{ border: 0, background: 'none' }} type="button">
            <PlusOutlined />
            <div style={{ marginTop: 8 }}>上传图片</div>
        </button>
    );

    const beforeUpload = async (file) => {
        // console.log('beforeUpload', file);
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
        if (!isJpgOrPng) {
            message.error('请上传JPG/PNG图片!');
        }
        const isLt8M = file.size / 1024 / 1024 < 8;
        if (!isLt8M) {
            message.error('图片必须小于 8MB!');
        }
        // console.log('upload', file);

        return isJpgOrPng && isLt8M;
    };

    React.useEffect(() => {
        const fetchShopId = async () => {
            const id = await getCurrentShopId();
            setShopId(id);
        };
        fetchShopId();
    }, []);

    React.useEffect(() => {
        if (!shopId) return;
        const fetchPageContent = async () => {
            const res = await getPageContent();
            console.log('res', res?.content);
            if (res?.content) {
                try {
                    res.content = JSON.parse(res.content);
                } catch (e) {}
            }
            pageContentRef.current = res?.content;
            setPageCtn({
                load: true,
                content: res?.content
            })
            initForm(res);
        };
        fetchPageContent();
    }, [shopId]);

    const initForm = (result) => {
        // 新建页面时 result 为空，需做空值保护
        if(!result) return;

        if(result.shareSmallImg) setShareSmallImg( [{url: result.shareSmallImg, thumbUrl: `${imageUrlPrefix}${result.shareSmallImg}?x-oss-process=image/resize,w_200`, name: '', type: "image/jpeg"}] );
        if(result.shareLargeImg) setShareLargeImg( [{url: result.shareLargeImg, thumbUrl: `${imageUrlPrefix}${result.shareLargeImg}?x-oss-process=image/resize,w_200`, name: '', type: "image/jpeg"}] );
        if(result.sharePosterImg) setSharePosterImg( [{url: result.sharePosterImg, thumbUrl: `${imageUrlPrefix}${result.sharePosterImg}?x-oss-process=image/resize,w_200`, name: '', type: "image/jpeg"}] );

        form.setFieldsValue({
            ...result,
        });
    };

    const getPageContent = async () => {
        const response = await fetch(`/api/page/get?shopId=${shopId}&pageId=${params.get('pageId')}`);
        const result = await response.json();

        if (result?.success) {
            return result.data;
        }
    };  

    const onSave = async () => {
        let values;
        // 表单校验失败会 reject 一个普通对象，需捕获并提示
        try {
            values = await form.validateFields();
        } catch (err) {
            const firstError = err?.errorFields?.[0]?.errors?.[0];
            message.error(firstError || '请完善必填项');
            return;
        }

        try {
            const url = window.location.pathname === '/mall/page/create' ? `/api/page/create` : `/api/page/update`;

            if(!!shareSmallImg){
                values.shareSmallImg = shareSmallImg[0]?.url || '';
            }
            if(!!shareLargeImg){
                values.shareLargeImg = shareLargeImg[0]?.url || '';
            }
            if(!!sharePosterImg){
                values.sharePosterImg = sharePosterImg[0]?.url || '';
            }

            if(pageContentRef.current || pageContentRef.current+'' === 'null') values.content = JSON.stringify(pageContentRef.current);
            if (!shopId) {
                message.error('店铺信息未加载完成');
                return;
            }
            values.shopId = shopId;

            const response = await fetch(`${url}?pageId=${params.get('pageId')}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(values)
            });

            // 非 JSON 响应（如网关/错误页）时给出明确提示，而不是抛未捕获错误
            const result = await response.json().catch(() => null);
            if(result?.success) {
                message.success('保存成功');
            }else {
                message.error(result?.data || '保存失败');
            }
        } catch (error) {
            console.error('保存失败:', error);
            message.error('保存失败，请重试');
        }
    };

    const getAvailableShops = async () => {
        const accId = window.__baseInfo.accId;
        const response = await fetch(`/api/shop/my-permission-list?accId=${accId}`);
        const result = await response.json();
        
        if (result && result.success) {
            // 过滤掉当前店铺
            const shops = result.data.filter(shop => shop.shopId !== shopId);
            setAvailableShops(shops);
        } else {
            message.error('获取店铺列表失败');
        }
    };

    const handleSyncClick = async () => {
        await getAvailableShops();
        setSelectedShopIds([]);
        setSyncModalVisible(true);
    };

    const handleSyncConfirm = async () => {
        if (selectedShopIds.length === 0) {
            message.warning('请至少选择一个店铺');
            return;
        }

        setSyncLoading(true);
        try {
            const pageId = params.get('pageId');
            if (!pageId) {
                message.error('页面ID不存在');
                return;
            }

            const syncData = {
                pageId: pageId,
                targetShopIds: selectedShopIds,
            };

            const response = await fetch('/api/page/sync', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(syncData)
            });

            const result = await response.json();
            if (result?.success) {
                message.success('同步成功');
                setSyncModalVisible(false);
            } else {
                message.error(result.data || '同步失败');
            }
        } catch (error) {
            console.error('同步失败:', error);
            message.error('同步失败');
        } finally {
            setSyncLoading(false);
        }
    };


    return (
        <div className="space-y-4">
            <SwitchShop readOnly={true} />
            <h2 className="admin-page-title">页面编辑</h2>
            <div className="admin-card p-4 md:p-6">
                <Form form={form} layout="vertical">
                    <Form.Item
                        label="页面名称"
                        name={'title'}
                        rules={[{ required: true, message: '请输入页面名称' }]}
                        extra={isSystemPage ? '系统页面名称由系统固定，不可修改' : undefined}
                    >
                        <Input className="admin-form-input" disabled={isSystemPage} />
                    </Form.Item>

                    <Form.Item 
                        hidden={true}
                        name={'code'}
                    > 
                        <Input />
                    </Form.Item>

                    <Form.Item 
                        label="分享标题"
                        name={'shareTitle'}
                    > 
                        <Input className="admin-form-input" />
                    </Form.Item>

                    <Form.Item 
                        label="分享小图"
                        name={'shareSmallImg'}
                        help="建议比例1:1，适用于H5分享微信好友及微信朋友圈"
                    > 
                        <Upload
                            fileList={shareSmallImg}
                            listType="picture-card"
                            className="avatar-uploader"
                            maxCount={1}
                            action="/api/upload/image"
                            beforeUpload={beforeUpload}
                            onChange={(file) => handleChange('shareSmallImg', file)}
                        >
                            {imageUrl ? <img src={imageUrl + '?x-oss-process=image/resize,w_200'} alt="avatar" style={{ width: '100%' }} /> : uploadButton}
                        </Upload>
                    </Form.Item>

                    <Form.Item 
                        label="分享大图"
                        name={'shareLargeImg'}
                        help="建议比例5:4，适用于小程序分享微信好友"
                    > 
                        <Upload
                            fileList={shareLargeImg}
                            listType="picture-card"
                            className="avatar-uploader"
                            maxCount={1}
                            action="/api/upload/image"
                            beforeUpload={beforeUpload}
                            onChange={(file) => handleChange('shareLargeImg', file)}
                        >
                            {imageUrl ? <img src={imageUrl + '?x-oss-process=image/resize,w_200'} alt="avatar" style={{ width: '100%' }} /> : uploadButton}
                        </Upload>
                    </Form.Item>
                </Form>
            </div>
            
            <Divider />
            {/* 编辑区标题和指引 */}
            <div className="mb-4">
                <div className="bg-gradient-to-r from-blue-50 to-indigo-50 border-l-4 border-blue-500 rounded-r-lg p-4">
                    <h3 className="text-base font-semibold text-blue-800 mb-2 flex items-center gap-2">
                        <span className="text-xl">💡</span>
                        <span>操作指引</span>
                    </h3>
                    <ul className="text-sm text-blue-700 space-y-1.5 ml-1">
                        <li className="flex items-start gap-2">
                            <span className="text-blue-500 mt-0.5">•</span>
                            <span>点击组件可编辑其属性</span>
                        </li>
                        <li className="flex items-start gap-2">
                            <span className="text-blue-500 mt-0.5">•</span>
                            <span>使用图标按钮调整组件顺序或删除</span>
                        </li>
                        <li className="flex items-start gap-2">
                            <span className="text-blue-500 mt-0.5">•</span>
                            <span>点击"添加组件"插入新组件</span>
                        </li>
                    </ul>
                </div>
            </div>
            {
                ((['custom', 'index'].includes(form.getFieldValue('code')) || window.location.pathname === '/mall/page/create') && pageCtn.load && shopId)? (
                    <div className="ml-0 md:ml-[60px]">
                        <PageEditor
                            accId={window.__baseInfo.accId}
                            shopId={shopId}
                            list={pageCtn?.content?.tree || []}
                            onChange={data => pageContentRef.current = {tree: data}}
                        />
                    </div>
                ) : null
            }
            <Divider />
            <div className="admin-form-actions justify-center">
                <Button href='/mall' size="large" className="min-w-[100px] h-12">返回</Button>
                <Button type="primary" onClick={onSave} size="large" className="min-w-[100px] h-12">保存</Button>
                {window.__baseInfo.isSuper && (
                    <Button onClick={handleSyncClick} size="large" className="min-w-[100px] h-12">
                        同步(请先保存)
                    </Button>
                )}
            </div>

            {/* 同步店铺选择弹窗 */}
            <Modal
                title="同步页面到其他店铺"
                open={syncModalVisible}
                onOk={handleSyncConfirm}
                onCancel={() => setSyncModalVisible(false)}
                confirmLoading={syncLoading}
                width={600}
            >
                <div className="mb-4">
                    <p className="text-text-secondary text-sm mb-3">
                        请选择要同步到的目标店铺（当前店铺已自动排除）
                    </p>
                    <Checkbox.Group
                        style={{ width: '100%' }}
                        value={selectedShopIds}
                        onChange={setSelectedShopIds}
                    >
                        <div className="max-h-[400px] overflow-y-auto space-y-2">
                            {availableShops.map(shop => (
                                <div key={shop.shopId} className="p-3 border border-border-light rounded hover:bg-bg-tertiary transition-colors">
                                    <Checkbox value={shop.shopId}>
                                        <span className="font-medium">{shop.title}</span>
                                    </Checkbox>
                                </div>
                            ))}
                            {availableShops.length === 0 && (
                                <div className="text-center py-8 text-text-secondary">
                                    暂无可同步的店铺
                                </div>
                            )}
                        </div>
                    </Checkbox.Group>
                </div>
                <div className="bg-blue-50 border-l-4 border-blue-500 p-3 rounded-r">
                    <p className="text-xs text-blue-700">
                        <strong>说明：</strong>
                        {form.getFieldValue('code') === 'custom' 
                            ? '自定义页面将创建新页面到目标店铺' 
                            : '系统页面将覆盖目标店铺的相同类型页面'}
                    </p>
                </div>
            </Modal>
        </div>
    );
};